import { api } from './api'; // your configured axios instance
import { Ride } from '../types/Ride';

// GET paginated list of rides (for admin table)
export const getRides = (
    page: number = 1,
    limit: number = 20,
    filters: { driverUid?: string; riderUid?: string } = {}
) =>
    api.get<{ data: Ride[]; page: number; total: number; limit: number; totalPages: number }>(
        '/admin/rides',
        {
            params: {
                page,
                limit,
                ...filters,
            }
        }
    );

// GET full details for one ride by ID
export const getRide = (rideId: number) =>
    api.get<Ride>(`/admin/ride/${rideId}`);

// You can add updateRide etc if needed as per your existing driverService/userService
